import { useTLang } from 'intl/intl';

export function useOrderDetailLang() {
  const _newText = useTLang({
    id: 'badge.new',
  });
  const _suggestionText = useTLang({
    id: 'adoption.suggestion',
  });
  const _scalePrintedDisclaimer = useTLang({
    id: 'adoption.scalePrinted',
  });
  const _handoffDisclaimer = useTLang({
    id: 'adoption.inputBagsDrinks',
  });
  const _userTagText = useTLang({
    id: 'adoption.userTag',
  });
  const _newUserDisclaimer = useTLang({
    id: 'adoption.newUser',
  });
  const _highValueUserDisclaimer = useTLang({
    id: 'adoption.highValueUser',
  });

  return {
    text: { new: _newText, suggestion: _suggestionText, userTag: _userTagText },
    disclaimer: {
      scalePrinted: _scalePrintedDisclaimer,
      handoff: _handoffDisclaimer,
      newUser: _newUserDisclaimer,
      highValueUser: _highValueUserDisclaimer,
    },
  };
}
